import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NavigationItem } from '../../../types';

@Component({
  selector: 'navigation-list-tabs',
  templateUrl: './navigation-list-tabs.component.html',
  styleUrls: ['./navigation-list-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationListTabsComponent {
  @Input() items?: NavigationItem[];
}
